import * as React from 'react';
import {useSelector} from 'react-redux';
import {getFormValues} from 'redux-form';
import {contentSelector} from '../../redux/selectors/resources';
import {useIsDesktop} from '../../shared/hooks/useIsDesktop';
import {Forms} from '../../shared/models/forms';
import {useAcceptorsResolver} from '../../shared/resolvers/acceptorsResolver';
import View from './view';

export const LoyaltyProgramScreen: React.FC = () => {
  useAcceptorsResolver();
  const isDesktop = useIsDesktop();
  const content = useSelector(contentSelector());
  const filterFormValues = useSelector(getFormValues(Forms.acceptorsFilterForm));
  const [filter, setFilter] = React.useState({});

  React.useEffect(() => {
    if (filterFormValues && !isDesktop) {
      setFilter(filterFormValues);
    }
  }, [filterFormValues, isDesktop]);

  return <View content={content} filter={filter} onFilterApply={setFilter} />;
};
